<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editData.owners" label="How Many Owners"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editData.owner_licenses" label="Owner's Licenses"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editData.owner_designations" label="Owner's Designations"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editData.years_in_business" label="Years In Business"></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'OwnerInfo',
        props: [
            'editData'
        ],
        data: () => ({
            name: 'OwnerInfo'
        }),
        mounted () {},
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/OwnerInfo.vue